import SideBarActions from "../Actions/ComponentsActions/SideBarActions";

export const sideBarReducer = (state, action) => {
  switch (action.type) {
    case SideBarActions.TOGGLE:
      return {
        ...state,
        open: !state.open,
      };
    case SideBarActions.CLOSE:
      return {
        ...state,
        open: false,
      };
    default:
      return state;
  }
};
